var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "made4fighters.myshopify.com",
        "incentive": {
            "type": "fixed_amount",
            "value": "10.00",
            "price_rule_id": 1217740079330,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "MTA0NjAz"
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#008080",
            "refer_text_color": "#ffffff",
            "web_position": "left-bottom",
            "mobile_position": "left-bottom"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get \u00a310 off",
            "popup_description": "Send your friends a \u00a310.00 discount off their purchase. Once they make a purchase, you'll earn \u00a310 too! This reward can be redeemed against future orders.",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#008080",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got \u00a310.00 Off",
            "shop_description": "Congrats! Your friend has gifted you a coupon. Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#008080",
            "shop_text_color": "#ffffff"
        }
    }
}